import { type } from './medicamentosTramitesActions';

export const medicamentosTramitesReducer = (state = {}, action) => {
  switch (action.type) {
    // List case
    case type.anualList: {
      return {
        ...state,
        anualList: action.payload,
        anualDate: action.date,
      };
    }
    case type.mensualList: {
      return {
        ...state,
        mensualList: action.payload,
        mensualDate: action.date,
      };
    }

    default:
      return state;
  }
};
